<template>
 <div>
  <label for="pcoprojeto-select" class="form-label">{{ label }}:</label>
  <MultiSelect
   v-model="selectedObjeto"
   :options="objeto"
   mode="single"
   :searchable="true"
   :close-on-select="true"
   valueProp="valor"
   trackBy="texto"
   label="texto"
   placeHolder="Selecione um Projeto"
   id="pcoprojeto-select"
  />
 </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";
import servico from "@/services/prestacaocontas/pcoprojeto/pcoprojeto.service";
import TextoValor from "@/models/texto-valor";
import { useStore } from "@/store";
import DadosLocais from "@/services/helper/storage";

export default defineComponent({
 name: "DropDownListPcoProjeto",
 props: {
  modelValue: {
   type: Number,
   default: null,
  },
  label: {
   type: String,
   default: "Projeto",
  },
  somenteNaoConcluido: {
   type: Boolean,
   default: false,
  },
  situacao: {
   type: Number,
   default: undefined,
  },
  gesEscolaId: {
   type: Number,
   default: null,
  },
  filtrarEscolaSelecionada: {
   type: Boolean,
   default: false,
  },
 },
 emits:["update:modelValue"],
 setup(props, { emit }) {
  const objeto = ref<TextoValor[]>([]);
  const selectedObjeto = ref<number | null>(props.modelValue ?? 0);
  const loading = ref(false);

  const obterGesEscolaId = () => {
   if (props.gesEscolaId) {
    const propValue = Number(props.gesEscolaId);
    if (!Number.isNaN(propValue) && propValue > 0)
     return propValue;
   }

   if (!props.filtrarEscolaSelecionada)
    return null;

   const storeValue = Number(useStore().getters.getCodigoEscola);
   if (!Number.isNaN(storeValue) && storeValue > 0)
    return storeValue;

   const storageValue = Number(DadosLocais.getInstance().getCodigoEscolaSelecionada());
   return Number.isNaN(storageValue) || storageValue <= 0 ? null : storageValue;
  };

  const fetchObjeto = async() => {
   loading.value = true;
   try {
    objeto.value = await servico.DropDownListPcoProjeto({
     somenteNaoConcluido: props.somenteNaoConcluido,
     situacao: props.situacao,
     gesEscolaId: obterGesEscolaId(),
    });
    if (!objeto.value.some((item) => item.valor === (props.modelValue ?? 0))) {
     selectedObjeto.value = 0;
    }
   } catch (err) {
    console.error("Erro ao carregar Projeto:", err);
   } finally {
    loading.value = false;
   }
  };

  watch(
   () => props.modelValue,
   (newValue) => {
    selectedObjeto.value = newValue ?? 0;
   },
   { immediate: true }
  );

  watch(selectedObjeto, (newValue) => {
   emit("update:modelValue", newValue && newValue > 0 ? newValue : null);
  });

  onMounted(fetchObjeto);

  watch(
   () => [props.somenteNaoConcluido, props.situacao, props.gesEscolaId, props.filtrarEscolaSelecionada],
   () => fetchObjeto()
  );

  return {
   objeto,
   selectedObjeto,
   loading,
  };
 },
});
</script>
